import { ProcessingOverlay } from '@components'

import { BorderRadius, Button, Color, Flex, Space, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { LogoAndBrandingSettingsFormFields } from '@features/invoicingSettings/modules/logoAndBranding'

import { useAppearanceLivePreview } from '../../../../hooks/useAppearanceLivePreview'
import { InvoicePreviewAppearanceProps } from '../../../../types/invoicePreviewAppearanceProps'
import { useInvoicePreviewAppearanceForm } from '../../contexts/invoicePreviewAppearanceFormContext'
import * as Styled from './styles'

export const InvoicePreviewAppearanceSettingsContent = ({
  documentType,
  updateInvoicePreviewAppearance,
}: InvoicePreviewAppearanceProps): ReactElement => {
  const { t } = useTranslation()
  const { handleSaveButtonClick, hasFailedToLoad, isInvoicePreviewLoading, isLoading, isProcessing, refetch } =
    useInvoicePreviewAppearanceForm()

  useAppearanceLivePreview({ documentType, updateInvoicePreviewAppearance })

  return (
    <Styled.InvoicePreviewAppearanceWrapper>
      {(isProcessing || isInvoicePreviewLoading) && (
        <ProcessingOverlay borderRadius={BorderRadius.R16} color={Color.White} withAnimation />
      )}
      <Text variant="h4">{t('external_invoices.appearance_settings.title')}</Text>
      <Space size="s24" />
      <LogoAndBrandingSettingsFormFields hasFailedToLoad={hasFailedToLoad} isLoading={isLoading} onRetry={refetch} />
      <Space size="s24" />
      <Flex justifyContent="flex-end">
        <Button
          disabled={hasFailedToLoad || isLoading || isProcessing}
          loading={isProcessing}
          onClick={handleSaveButtonClick}
        >
          {t('external_invoices.appearance_settings.save_changes')}
        </Button>
      </Flex>
    </Styled.InvoicePreviewAppearanceWrapper>
  )
}
